export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_green.63a63c5a.jpg";